// timesheet/penalty -- penalty
import axios from '@/libs/api.request'
const penaltyService = {
  // 列表
  getPenaltyPage: data => {
    return axios.request({
      url: '/penalty/page',
      data,
      method: 'POST'
    })
  },
  // 详情
  getPenaltyDetail: data => {
    return axios.request({
      url: '/penalty/detail',
      data,
      method: 'POST'
    })
  }
}
export default penaltyService
